<template>
  <div
    v-if="isLoading"
    class="loader"
  />
  <div
    v-else
    class="delete_form">
    <ul>
      <li>
        <button
          class="btn mb15"
          @click="addContract">はい</button>
      </li>
      <li>
        <button
          class="btn btn-wt"
          @click="$emit('close')">いいえ</button>
      </li>
    </ul>
  </div>
</template>
<script>
  import OrganizationApi from '../../../api/organizations.js'

  export default {
    props: {
      organizationMember: {
        type: Object,
        requires: true,
        default: null
      },
    },
    data () {
      return {
        isLoading: false
      }
    },
    methods: {
      addContract() {
        this.isLoading = true
        OrganizationApi.deleteOrganizationMember(this.organizationMember.id).then((res) => {
          this.$emit('deleted', res.data)
        })
      }
    }
  }
</script>
<style scoped>
  .delete_form li {
    padding: 20px 0;
    height: auto !important;
  }
</style>
